import React, { useState, useEffect } from 'react';
import {
    TwoColumnScaffold,
    LeftColumn,
    RightColumn,
    FooterRow
} from 'pages/studyOverview/components/TwoColumnScaffold';
import CategorizedSideNav from './CategorizedSideNav';
import styles from './Tasks.scss';
import MyTasks from '../../../workflow/containers/TasksV4/MyTasks';
import SentTasks from '../../../workflow/containers/TasksV4/SentTasks';
import { connect } from 'react-redux';
import newInboxActions from '../../../workflow/actions/newInbox';
import lodash from 'lodash';
import { Box } from '@material-ui/core';
import { MultiSignForTaskButton } from '../../../workflow/components/NewInbox/Desktop/TaskWindowV4/TaskWindowV4';
import newInboxSelectors from '../../../workflow/selectors/newInbox';
import WithResizeScreen, { SCREEN_MODES } from '../../../common/components/WithResizeScreen/WithResizeScreen';
import MobileMytaskV4 from '../../../workflow/containers/NewInbox/MobileMytaskV4';

const buildMyTasksLinks = () => {
    return [
        {
            title: 'My Tasks',
            links: [
                { to: '/tasks/my-tasks/open', title: 'Open' },
                { to: '/tasks/my-tasks/completed', title: 'Completed' },
            ],
        },
    ];
};

const buildSentTasksLinks = () => {
    return [
        {
            title: 'Sent Tasks',
            links: [
                { to: '/tasks/sent-tasks/open', title: 'Open' },
                { to: '/tasks/sent-tasks/completed', title: 'Completed' },
            ],
        },
    ];
};

function Tasks(props) {
    const myTasksLinks = buildMyTasksLinks();
    const sentTasksLinks = buildSentTasksLinks();
    const [activeLink, setActiveLink] = useState(null);

    const handleLinkClick = (link) => {
        setActiveLink(link.to);
    };

    useEffect(() => {
        const { pathname } = props.location;
        props.setTaskForDetailDisplay({});
        if (pathname === '/tasks' && props.screenMode == SCREEN_MODES.DESKTOP) {
            setActiveLink('/tasks/my-tasks/open');
        } else if (props.screenMode == SCREEN_MODES.DESKTOP) {
            if (pathname.split('/').length < 4)
                setActiveLink(pathname + '/open');
            else
                setActiveLink(pathname);

        }
        return () => {
            props.setTaskForDetailDisplay({});
        };
    }, [props.location, props.screenMode]);

    if (props.screenMode !== SCREEN_MODES.DESKTOP) {
        return (
            <MobileMytaskV4 />
        );
    }
    return (
        <div className={styles.taskContainer}>
            <TwoColumnScaffold className={[styles.mainContentContainer, !props.tasksForMultiSign.length ? styles.heightWithoutFooter : styles.heightWithFooter]}>

                <LeftColumn>
                    <CategorizedSideNav
                        categories={[
                            { title: 'My Tasks', links: myTasksLinks[0].links },
                            { title: 'Sent Tasks', links: sentTasksLinks[0].links },
                        ]}
                        activeLink={activeLink}
                        setActiveLink={setActiveLink}
                        handleLinkClick={handleLinkClick}
                    />
                </LeftColumn>
                <RightColumn className={styles.bindersContainer} explicitRightColumnStyles={true}>
                    {activeLink === '/tasks/my-tasks/open' && <MyTasks status='pending' />}
                    {activeLink === '/tasks/my-tasks/completed' && <MyTasks status='complete' />}
                    {activeLink === '/tasks/sent-tasks/open' && <SentTasks status='pending' />}
                    {activeLink === '/tasks/sent-tasks/completed' && <SentTasks status='complete' />}
                </RightColumn>

            </TwoColumnScaffold>
            <FooterRow className={[props.tasksForMultiSign.length && styles.footerRowContainer, styles.footerRowContainerNoHeight]} >
                <Box display="flex" justifyContent="flex-end">
                    <MultiSignForTaskButton onClick={props.changeView} />
                </Box>
            </FooterRow>
        </div >
    );
}
const mapStateToProps = state => ({
    tasksForMultiSign: lodash.get(state, 'tasksForMultiSign', []),
    taskWindowDetail: newInboxSelectors.getTaskForDetailDisplay(state),
});

const mapDispatchToProps = {
    setTaskForDetailDisplay: newInboxActions.setTaskForDetailDisplay,
    toggleTaskForMultiSign: newInboxActions.toggleTaskForMultiSign,
    changeView: newInboxActions.changeView,


};
export default connect(mapStateToProps, mapDispatchToProps)(WithResizeScreen(Tasks));